class ProductRecently extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'product-recently-storage';
    this.sectionId = this.dataset.sectionId;
    this.handle = this.dataset.handle;
    this.limit = this.dataset.limit;
    this.slider = this.querySelector('slider-component');
    this.content = this.querySelector('[data-product-recently]');


    this._state = this._getState();
    this.onShow(this.handle);
  }

  onShow(handle) {
    this._state.products = this._state.products.filter(product => product.handle !== handle);
    const products = this._state.products;
    if (products.length > 0) {
      this.classList.remove('hidden');
      this.slider.classList.add('is-loading');
      this.content.innerHTML = '';
      this._addProducts(products);
    } else {
      this.classList.add('hidden');
      this.onAdd(this.handle);
    }
  }

  async _addProducts(products) { 
    for (let i in products) {
      await fetch(`/products/${products[i].handle}?section_id=${this.sectionId}`)
      .then(response => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.renderProductGrid(html.querySelector('[data-product-recently-card]'));
        if (i == products.length - 1) {
          this.slider.init();
          this.slider.classList.remove('is-loading');
          this.onAdd(this.handle);
        }
      });
    }
  }

  renderProductGrid(html) {
    if (html) this.content.appendChild(html.querySelector('[data-carousel-item]'));
  }

  onAdd(handle) {
    this._state.products.unshift({handle});
    if (this._state.products.length > this.limit) {
      this._state.products.pop();
    }
    this._save();
  }

  includes(handle) {
    return this._state.products.some(product => product.handle === handle);
  }

  _load() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey));
    } catch (e) {
      return null;
    }
  }

  _save() {
    localStorage.setItem(this.storageKey, JSON.stringify(this._state));
  }

  _getState() {
    const savedState = this._load();

    if (savedState) {
      return { ...savedState};
    }

    return {
      products: []
    };
  }
}

customElements.define('product-recently', ProductRecently);
